import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { metaCallback } from './services/auth';
import Login from './Login';
import Principal from './Principal';
import Restablecer from './Restablecer';
import VerificacionEmail from './VerificacionEmail';
import WhatsAppConnect from './pages/WhatsAppConnect';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TerminosServicio from './pages/TerminosServicio';
import EliminacionDatos from './pages/EliminacionDatos';
import './App.css';

// Componente que captura el "code" de la URL, sin importar la ruta
function CodeHandler() {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const code = params.get('code');

    if (code) {
      console.log('🔑 [DEBUG] Código capturado en App.js:', code);
      // Limpiar la URL para evitar reenvíos
      window.history.replaceState({}, document.title, window.location.pathname);

      metaCallback(code)
        .then((res) => {
          console.log('✅ [DEBUG] Respuesta del backend:', res);
        })
        .catch((err) => {
          console.error('❌ [DEBUG] Error en metaCallback:', err);
        });
    }
  }, [location]);

  return null;
}

function App() {
  return (
    <BrowserRouter>
      <CodeHandler />
      <Routes>
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<Principal />} />
        <Route path="/restablecer" element={<Restablecer />} />
        <Route path="/verificar" element={<VerificacionEmail />} />
        <Route path="/whatsapp-connect" element={<WhatsAppConnect />} />
        <Route path="/politica-privacidad" element={<PrivacyPolicy />} />
        <Route path="/terminos-servicio" element={<TerminosServicio />} />
        <Route path="/eliminacion-datos" element={<EliminacionDatos />} />
        {/* Ruta para admin (la crearás después) */}
        {/* <Route path="/admin/*" element={<AdminLayout />} /> */}
      </Routes>
    </BrowserRouter>
  );
}

export default App;